import "../styles/external/animate.css/animate.css";
import { isInViewport } from '@roghz/isinviewport';
import debounce from 'debounce';

document.addEventListener('DOMContentLoaded', () => {
    const elements = Array.from(document.querySelectorAll('[data-animation]'));


    elements.forEach(el => {
        if (el.dataset.childs === 'true') {
            Array.from(el.children).forEach(child => {
                if (child.classList.contains('wp-block-spacer')) return;
                child.classList.add('animate__hidden');
            });
        } else {
            el.classList.add('animate__hidden');
        }
    });


    const animateElements = () => {
        elements.forEach(el => {
            if (isInViewport(el)) {
                const animClass = el.dataset.animation;
                if (el.dataset.childs === 'true') {
                    let idx = 0;
                    Array.from(el.children).forEach(child => {
                        if (child.classList.contains('wp-block-spacer')) return;
                        const delay = (parseFloat(el.dataset.delay) * 0.1 || 0) + idx * 0.15;
                        child.style.animationDelay = `${delay}s`;
                        child.classList.remove('animate__hidden');
                        child.classList.add('animate__animated', animClass);
                        idx++;
                    });
                } else {
                    const delay = parseFloat(el.dataset.delay) * 0.1 || 0;
                    el.style.animationDelay = `${delay}s`;
                    el.classList.remove('animate__hidden');
                    el.classList.add('animate__animated', animClass);
                }
            }
        });
    };

    const handleScroll = debounce(animateElements, 50);
    animateElements();
    window.addEventListener('scroll', handleScroll);
});
